module.exports = __webpack_public_path__ + "static/media/2024.c48a6e5f.csv";